import React, {useEffect, useRef} from 'react';
import { useState } from "react";
import DropDownPicker, { ItemType } from "react-native-dropdown-picker";
import { TextInputProps, Text, Provider as PaperProvider, Modal, Portal } from "react-native-paper";
import { View,StyleSheet, TextInput, Alert } from "react-native";
import { MyButton, TextInputTemp } from "./buttonsAndControls";
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import firebase from 'firebase/app';
import 'firebase/firestore';
import { addDoc, collection, getDocs, getFirestore, orderBy, query, serverTimestamp, updateDoc } from 'firebase/firestore';
import { branch, companyDir } from './StockAwareTempData';


const darkColour='#2a2d3e'

interface VendorsList {
  label: string;
  value: string;
}

const NewSales = ({onClicked=()=>{}, showModal=false}) => {

	const db = getFirestore();
	const inputRef1 = useRef<TextInput>(null)
	const [notesText, setNotesText] = useState('')
	const [qtyNum, setQtyNum] = useState('');
  const [openmm, setOpenmm] = useState(false);
  const [valuemm, setValuemm] = useState<string>('');
  const [itemsmm, setItemsmm] = useState([
    {label: '1mm', value: '1mm'},
    {label: '2mm', value: '2mm'},
    {label: '3mm', value: '3mm'},
    {label: '4mm', value: '4mm'},
    {label: '5mm', value: '5mm'},
    {label: '6mm', value: '6mm'},
		{label: '7mm', value: '7mm'},
    {label: '8mm', value: '8mm'},
    {label: '9mm', value: '9mm'},
    {label: '10mm', value: '10mm'},
    {label: '11mm', value: '11mm'},
    {label: '12mm', value: '12mm'},
    {label: '13mm', value: '13mm'},
		{label: '14mm', value: '14mm'},
    {label: '15mm', value: '15mm'},
    {label: '16mm', value: '16mm'},
    {label: '17mm', value: '17mm'},
    {label: '18mm', value: '18mm'},
    {label: '19mm', value: '19mm'},
    {label: '20mm', value: '20mm'}
  ]);

  const [openClr, setOpenClr] = useState(false);
  const [valueClr, setValueClr] = useState('');
  const [itemClr, setItemClr] = useState([
    {label: 'red rose', value: 'red rose'},
    {label: 'customer code', value: 'customer code'},
    {label: 'akala', value: 'akala'},
    {label: 'brown masonia', value: 'brown masonia'},
    {label: 'white masonia', value: 'White Masonia'},
    {label: 'dark walnut', value: 'dark Walnut'},
    {label: 'mipple', value: 'mipple'},
    {label: 'red', value: 'red'},
    {label: 'blue', value: 'blue'},
    {label: 'pink', value: 'Pink'},
    {label: 'off whie', value: 'off white'},
    {label: 'green', value: 'green'},
   
  ]);

  const [openVendor, setOpenVendor] = useState(false);
  const [valueVendor, setValueVendor] = useState('');
  const [itemsVendor, setItemsVendor] = useState<VendorsList[]>([]);

  const [openBoard, setOpenBoard] = useState(false);
  const [valueBoard, setValueBoard] = useState('');
  const [itemsBoard, setItemsBoard] = useState([
    {label: 'MDF', value: 'MDF'},
		{label: 'HDF', value: 'HDF'},
		{label: 'HDF block-board', value: 'HDF block-board'},
		{label: 'acrylic MDF', value: 'acrylic MDF'},
		{label: 'acrylic HDF', value: 'acrylic HDF'},
		{label: 'marine', value: 'marine'},
    {label: 'plywood', value: 'plywood'},
  ]);

  const [buyOpen, setBuyOpen] = useState(false);
  const [buyValue, setBuyValue] = useState('');
  const [buyItem, setBuyItem] = useState<ItemType<string>[]>([]);
	const [isBuyPressed, setIsBuyPressed] = useState(false)
  
  const [sellOpen, setSellOpen] = useState(false);
  const [sellValue, setSellValue] = useState('');
  const [sellItem, setSellItem] = useState<ItemType<string>[]>([]);
	const [isSellPressed, setIsSellPressed] = useState(false)

	const fetchVendors = async() => {
		const purchaseRecordRef = collection(db, companyDir, branch, 'purchaseRecord');

		// Create a query to group by 'Vendor' and order by 'ID' in descending order
		const q = query(purchaseRecordRef, orderBy('vendor'));

		getDocs(q).then((querySnapshot) => {
			const vendorsMap = new Map(); // Use a Map to ensure unique vendors
			
			querySnapshot.forEach((doc) => {
				const data = doc.data();
				const vendor = data.vendor;
				// Check if the vendor is not already in the map
				if (!vendorsMap.has(vendor)) {
					vendorsMap.set(vendor, {
						label: vendor,
						value: vendor,
					});
				}
			});
		
			// Convert the Map values to an array
			const vendorsArray = Array.from(vendorsMap.values());
		
			// Set the state or perform any other action with vendorsArray
			setItemsVendor(vendorsArray);
		}).catch((error) => {
			console.error('Error executing Firestore query', error);
		});
	}

	useEffect(() => {
		try {
			fetchVendors()
		}
		catch (error) {
			console.log(error)
		}
	}, []);

  const leaveOnlySell =()=>{
		setIsSellPressed((prev) => !prev)
    sellValue.trim() ? setSellItem ([{label: sellValue, value: sellValue}]) : setSellItem([]);
    setOpenClr(false)
    setOpenVendor(false)
    setOpenBoard(false)
    setBuyOpen(false)
    setOpenmm(false)
  }

  const leaveOnlyBuy =()=>{
		setIsBuyPressed((prev) => !prev)
    buyValue.trim() ? setBuyItem ([{label: buyValue, value: buyValue}]) : setBuyItem([]);
    setOpenClr(false)
    setOpenVendor(false)
    setOpenBoard(false)
    setSellOpen(false)
    setOpenmm(false)
  }

  const leaveOnlymm =()=>{
      setOpenClr(false)
      setOpenVendor(false)
      setOpenBoard(false)
      setBuyOpen(false)
      setSellOpen(false)
  }

  const leaveOnlyColour =()=>{
    setOpenmm(false)
    setOpenVendor(false)
    setOpenBoard(false)
    setBuyOpen(false)
    setSellOpen(false)
  }

  const leaveOnlyVendor =()=>{
    setOpenClr(false)
    setOpenmm(false)
    setOpenBoard(false)
    setBuyOpen(false)
    setSellOpen(false)
  }

  const leaveOnlyBoard=()=>{
    setOpenClr(false)
    setOpenmm(false)
    setOpenVendor(false)
    setBuyOpen(false)
    setSellOpen(false)
  };

	const handleQuantity = (text: string) => {
		setQtyNum(text)
	}

	const updateStock = async() => {
		if (qtyNum.trim() === '' || qtyNum.charAt(0) === '0' || valueVendor.trim() === '' || valueBoard.trim() === '' || 
			valuemm.trim() === '' || valueClr.trim() === '' || buyValue.trim() === '' || sellValue.trim() === '') {
			window.alert('Failed request.\nYou must make sure to fully specify the new stock description')
		} else {
			const itemName = `${valuemm} ${valueClr} ${valueBoard}`
			const stocksCollection = collection(db, companyDir, branch, 'stocks');
			const querySnapshot = await getDocs(stocksCollection);

			let existingItem = null;
			querySnapshot.forEach((doc) => {
				const data = doc.data();
				if (data.itemName === itemName) {
					existingItem = doc;
				}
			});

			if (existingItem?.exists) {
				// Item already exists, update it
				const newQuantity = existingItem.data().quantity + parseInt(qtyNum, 10);
			
				const newPrice = parseInt(sellValue, 10);
				const now = serverTimestamp();
			
				await updateDoc(existingItem.ref, {
					quantity: newQuantity,
					itemPrice: newPrice,
					lastUpdated: now,
				});

			} else {
				// Item doesn't exist, add it
				const newStock = {
					quantity: parseInt(qtyNum, 10),
					itemName: itemName,
					itemPrice: parseInt(sellValue, 10),
					lastUpdated: serverTimestamp(),
				};
				const stockRef = await addDoc(stocksCollection, newStock);
				existingItem = { ref: stockRef };
			}

			const purchaseRecordCollection = collection(db, companyDir, branch, 'purchaseRecord');
			const newPurchaseRecord = {
				quantity: parseInt(qtyNum, 10),
				itemName: itemName,
				vendor: valueVendor,
				lastUpdated: serverTimestamp(),
				amountPaid: parseInt(buyValue, 10),
				notes: notesText,
				itemPrice: parseInt(sellValue, 10),
			};

			await addDoc(purchaseRecordCollection, newPurchaseRecord);


			const dialogResult = window.confirm(`Successful\n${qtyNum} sheets of ${valuemm} ${valueClr} ${valueBoard} has been successfully added to stocks.\n\nDo you want to perform another transaction?`)
			
			if (dialogResult === true) {
        startAfresh()
      } else {
				onClicked(); 
				startAfresh()
			}
   
		}

	}

	const startAfresh = () => {
		setQtyNum('');
		setValueVendor('');
		setValueBoard('');
		setValuemm('');
		setValueClr('');
		setNotesText('');
		setBuyValue('');
		setSellValue('');
		if (inputRef1.current) {
			inputRef1.current.clear();
		}
	} 
  
  return (
		<View>
			<MyButton 
				btnText='Add new stock' 
				btnBorWdt={2} 
				btnColor='white'
				btnTxtClr={darkColour}
				btnPadding={8}
				hndClicked={onClicked}
			/>
      <Portal>
				<Modal visible={showModal} onDismiss={() => showModal} dismissable={false} contentContainerStyle={styles.modalContainer}>
					<View style={{...styles.modalContainer, marginLeft:0}}>
						<View style={{flexDirection:'row', width:500, alignSelf:'center', marginBottom:40, marginTop:100}}>
							<View style={{alignSelf:'flex-start'}}>
								<MyButton btnText='Close' btnColor='white' btnHeight={40} btnTxtClr= {darkColour} 
								btnBorClr={darkColour} btnBorWdt={2} hndClicked={()=> {onClicked(); startAfresh()}} />
							</View>

							<View style={{flexDirection:'column', width:300}}>
								<View style={{alignSelf:'flex-end'}}>
									<MyButton btnText='Update Stock' btnColor={darkColour} btnHeight={40} btnTxtClr='white' hndClicked={updateStock} />
								</View>
							</View>
						</View>
						<View style={{alignSelf:'center'}}>
							<TextInput
								placeholder='Additional notes, if there is any.'
								multiline
								numberOfLines={4}
								style={styles.notesText}
								onChangeText={(text)=> setNotesText(text)}
							/>
						</View>
					  
						<Text style={styles.descriptionText}>
							{valueVendor} supplied a total of {qtyNum} sheets of {valuemm} {valueClr} {valueBoard} boards.
						</Text>
					
            <View style={{flexDirection:'row'}}>
              <View style={{width:150, height:40, marginLeft:0, backgroundColor: darkColour, justifyContent:'center', borderWidth:1, borderRightWidth:0, borderRadius:10, borderTopRightRadius:0, borderBottomRightRadius:0, marginRight:-10, marginTop:10}}>
                <Text style={styles.dropdownText}>
                  Buy per board {'(₦)'}
                </Text>
              </View>
              <View style={{width:100, height:40, margin:10}}>
								<DropDownPicker
									theme="DARK"
									searchable={true}
									searchPlaceholder='Price'
									searchTextInputStyle={{color:'black', width: 75}}
									modalAnimationType='slide'
									placeholder='Not set'
									style={{borderRadius:10, borderLeftWidth:0, borderTopLeftRadius:0, borderBottomLeftRadius:0}}
									open={buyOpen}
									onPress={leaveOnlyBuy}
									value={buyValue}
									items={buyItem}
									setOpen={setBuyOpen}
									setValue={setBuyValue}
									setItems={setBuyItem}
									listItemContainerStyle={{backgroundColor:'white'}}
									listItemLabelStyle={{color:'black'}}
									textStyle={{...styles.dropdownText, marginLeft:-10}}
                  searchContainerStyle={{marginLeft:10}}	
                  arrowIconContainerStyle={{width:15}}
									onChangeSearchText={async (str) => {
                    const dig = str.replace(/[^0-9]/g, '');
                    isBuyPressed 
                    ? (setBuyValue(dig), (dig.trim() ? setBuyItem ([{label: dig, value: dig}]) : setBuyItem([])))
                    : setBuyValue((prev) => prev), setIsBuyPressed(true)
                   
                    return 
                  }}
                  
              	/>
							</View>
              <View style={{width:150, height:40, backgroundColor: darkColour, justifyContent:'center', borderWidth:1, borderRightWidth:0, borderRadius:10, borderTopRightRadius:0, borderBottomRightRadius:0, marginRight:-10, marginTop:10}}>
                <Text style={styles.dropdownText}>
                  Sell per board {'(₦)'}
                </Text>
              </View>
              <View style={{width:100, height:40, margin:10, marginRight:0}}>
								<DropDownPicker
									theme="DARK"
									searchable={true}
									searchPlaceholder='Price'
									searchTextInputStyle={{color:'black', width: 75}}
									modalAnimationType='slide'
									placeholder='Not set'
									style={{borderRadius:10, borderLeftWidth:0, borderTopLeftRadius:0, borderBottomLeftRadius:0}}
									open={sellOpen}
									onPress={leaveOnlySell}
									value={sellValue}
									items={sellItem}
									setOpen={setSellOpen}
									setValue={setSellValue}
									setItems={setSellItem}
									listItemContainerStyle={{backgroundColor:'white'}}
									listItemLabelStyle={{color:'black'}}
									textStyle={{...styles.dropdownText, marginLeft:-10}}
                  searchContainerStyle={{marginLeft:10}}	
                  arrowIconContainerStyle={{width:15}}
									
									onChangeSearchText={async (str) => {
                    const dig = str.replace(/[^0-9]/g, '');
                    isSellPressed 
                    ? (setSellValue(dig), (dig.trim() ? setSellItem ([{label: dig, value: dig}]) : setSellItem([])))
                    : setSellValue((prev) => prev), setIsSellPressed(true)
                   
                    return 
                  }}
                  
                          
                  
              	/>
							</View>
            </View>

						<View style={{flexDirection:'row', alignSelf:'center', marginTop:0}}>
							<View style={{width:190, height:40, margin:10, marginRight:0}}>
								<DropDownPicker
									theme="DARK"
									addCustomItem={true}
									searchable={true}
									searchPlaceholder='Search/Add'
									searchTextInputStyle={{color:'black', width: 165}}
									modalAnimationType='slide'
									placeholder='Board'
									style={{borderRadius:10}}
									open={openBoard}
									onPress={leaveOnlyBoard}
									value={valueBoard}
									items={itemsBoard}
									setOpen={setOpenBoard}
									setValue={setValueBoard}
									setItems={setItemsBoard}
									listItemContainerStyle={{backgroundColor:'white'}}
									listItemLabelStyle={{color:'black'}}
									textStyle={styles.dropdownText}								/>
							</View>

							<View style={{width:125, height:40, margin:10, marginRight:0}}>
								<DropDownPicker
									theme="DARK"
									addCustomItem={true}
									searchable={true}
									searchPlaceholder='Search/Add'
									searchContainerStyle = {{width: 50}}
									searchTextInputStyle={{color:'black', width: 115, marginLeft: -6}}
									modalAnimationType='slide'
									placeholder='Thickness'
									style={{borderRadius:10}}
									open={openmm}
									onPress={leaveOnlymm}
									value={valuemm}
									items={itemsmm}
									setOpen={setOpenmm}
									setValue={setValuemm}
									setItems={setItemsmm}
									listItemContainerStyle={{backgroundColor:'white'}}
									listItemLabelStyle={{color:'black'}}
									textStyle={styles.dropdownText}								/>
							</View>
							<View style={{width:175, height:40, margin:10}}>
								<DropDownPicker
									theme="DARK"
									addCustomItem={true}
									searchable={true}
									searchPlaceholder='Search/Add'
									searchTextInputStyle={{color:'black', width: 150}}
									modalAnimationType='slide'
									placeholder='Colour'
									style={{borderRadius:10}}
									open={openClr}
									onPress={leaveOnlyColour}
									value={valueClr}
									items={itemClr}
									setOpen={setOpenClr}
									setValue={setValueClr}
									setItems={setItemClr}
									
									listItemContainerStyle={{backgroundColor:'white'}}
								
									listItemLabelStyle={{color:'black'}}
									textStyle={styles.dropdownText}								/>
							</View>
						</View>
			
						<View style={{flexDirection:'row', alignSelf:'center'}}>
							<View>
								<TextInputTemp lTxt='Qty' plhrTxt='Quantity' cnWidth={230} lbWidth={50}  txtWidth={178} 
								makeDigits={true} refObject={inputRef1} onChangeText={handleQuantity} />
							</View>

							<View style={{width:270, height:40, margin:10, marginLeft:0}}>
								<DropDownPicker
									theme="DARK"
									addCustomItem={true}
									searchable={true}
									searchPlaceholder='Search/Add'
									searchTextInputStyle={{color:'black', width: 245}}
									modalAnimationType='slide'
									placeholder='Vendor'
									style={{borderRadius:10}}
									open={openVendor}
									onPress={leaveOnlyVendor}
									value={valueVendor}
									items={itemsVendor}
									setOpen={setOpenVendor}
									setValue={setValueVendor}
									setItems={setItemsVendor}
								
									listItemContainerStyle={{backgroundColor:'white'}}
								
									listItemLabelStyle={{color:'black'}}
									textStyle={styles.dropdownText}
								/>
							</View>
						</View>
						<Text style={styles.headerText}>
									Add to Stock
						</Text>
					</View>
        </Modal>
			</Portal>
		</View>
  
  );
}

const styles = StyleSheet.create ({
	headerText: {
		alignSelf:'center', 
		color:darkColour, 
		fontFamily:'century gothic', 
		fontSize:20, 
		fontWeight:'600', 
		margin:20, 
		marginRight:10
	},
	modalContainer: {
		justifyContent: 'center',
		alignItems: 'center',
		alignSelf:'center',
		backgroundColor: 'white',
		flexDirection:'column-reverse', 
		width:550, 
		height:700, 
		borderWidth:2, 
		borderColor:darkColour, 
		borderRadius:10, 
  },
	overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1,
  },
	descriptionText: {
		alignSelf:'center', 
		color:'black', 
		fontFamily:'century gothic', 
		fontSize:16, 
		fontWeight:'300', 
		margin:20, 
		height:50, 
		marginRight:10
	},
	dropdownText: {
		color:'white', 
		fontFamily:'century gothic', 
		fontSize:16, 
		fontWeight:'300', 
		textAlign:'center'
	},
	notesText: {
    borderWidth: 1,
    borderRadius:10,
    borderColor: darkColour,
    width:480,
    height:150,
    padding:10,
    color:'black', 
    fontFamily:'century gothic', 
    fontSize:16, 
    fontWeight:'300',
    marginBottom:10,
    marginHorizontal:0,
    alignSelf:'center'
  },
})

export default NewSales